var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 7L14.798 14.8686C14.402 15.2646 14.204 15.4627 13.9757 15.5368C13.7748 15.6021 13.5585 15.6021 13.3576 15.5368C13.1293 15.4627 12.9313 15.2646 12.5353 14.8686L9.79803 12.1314C9.40201 11.7354 9.204 11.5373 8.97567 11.4632C8.77483 11.3979 8.55848 11.3979 8.35764 11.4632C8.12931 11.5373 7.9313 11.7354 7.53529 12.1314L2.66666 17M22.6667 7H15.6667M22.6667 7V14",
    stroke: "#379E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlty);
export default __webpack_public_path__ + "static/media/alty.9c75b080bdc9694b9f3091f418c53fd6.svg";
export { ForwardRef as ReactComponent };